const inBrowser = typeof window !== 'undefined';
const Time =
    inBrowser && window.performance && window.performance.now
        ? window.performance
        : Date;

function getUrl(path) {
    const href = window.location.href;
    const i = href.indexOf('#');
    const base = i >= 0 ? href.slice(0, i) : href;
    return base + '#' + path;
}

function pushState(url) {
    // try...catch the pushState call to get around Safari
    // DOM Exception 18 where it limits to 100 pushState calls
    const history = window.history;
    try {
        // _key = genKey();
        history.pushState({ key: Time.now().toFixed(3) }, '', url);
    } catch (e) {
        window.location.assign(url);
    }
}

const supportsPushState =
    inBrowser &&
    (function() {
        const ua = window.navigator.userAgent;

        if (
            (ua.indexOf('Android 2.') !== -1 ||
                ua.indexOf('Android 4.0') !== -1) &&
            ua.indexOf('Mobile Safari') !== -1 &&
            ua.indexOf('Chrome') === -1 &&
            ua.indexOf('Windows Phone') === -1
        ) {
            return false;
        }
        return window.history && 'pushState' in window.history;
    })();

export function pushHash(path) {
    if (supportsPushState) {
        pushState(getUrl(path));
    } else {
        window.location.hash = path;
    }
}



// WEBPACK FOOTER //
// ./src/util/dmp/push-hash.js